import { type HeapProperties } from "@/types/heap";

export const identifyHeapUser = (
  userId: string,
  userProperties?: HeapProperties
) => {
  if (typeof window.heap?.identify === "function") {
    window.heap.identify(userId);
  }

  if (userProperties && typeof window.heap?.addUserProperties === "function") {
    window.heap.addUserProperties(userProperties);
  }
};
